/**
 * Represents PWAException
 */
class PWAException {
	code: string
	message: string

	/**
	 * @constructor
	 * @param {string} code - code
	 * @param {string} message - message
	 */
	constructor(code, message?) {
		this.code = code;

		if (message) {
			this.message = message;
		}
	}
}

export default PWAException;
